import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not send reset link.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="forgot-password-page"
      className="max-w-[520px] mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-24 fade-up"
    >
      <p className="overline">Account</p>
      <h1 className="font-serif font-light text-3xl md:text-4xl text-brand-dark mt-6 leading-tight">
        Reset your <span className="italic">password</span>.
      </h1>

      {sent ? (
        <div data-testid="forgot-password-sent" className="mt-10 space-y-6 text-brand-neutral">
          <p>
            If an account exists for <b className="text-brand-dark">{email}</b>, we've just sent a
            password reset link to that address. The link will expire in one hour.
          </p>
          <p className="text-sm">
            Please check your inbox — and your spam folder just in case.
          </p>
          <Link
            data-testid="back-to-login-link"
            to="/login"
            className="inline-block underline underline-offset-4 text-brand-accent mt-4"
          >
            Back to sign in
          </Link>
        </div>
      ) : (
        <>
          <p className="mt-4 text-brand-neutral">
            Enter the email address you registered with. We'll send you a one-time link
            to choose a new password.
          </p>
          <form onSubmit={onSubmit} className="mt-10 space-y-6">
            <label className="block">
              <span className="overline block mb-1">Email</span>
              <input
                data-testid="forgot-password-email"
                required
                type="email"
                className="flushed-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <button
              data-testid="forgot-password-submit"
              disabled={busy}
              className="btn-primary mt-6"
            >
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>
          <p className="mt-10 text-sm text-brand-neutral">
            Remembered it?{" "}
            <Link to="/login" className="text-brand-accent">
              Sign in
            </Link>
          </p>
        </>
      )}
    </div>
  );
}
